import { Component, Input, forwardRef, Output, EventEmitter, OnInit, ElementRef, ViewChild, ViewChildren } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BaseControlValueAccessor } from '../base-control-value-accessor';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Timepicker } from 'materialize-css';
import moment from 'moment-timezone';
import { TimepickerDirective } from "./time-picker.directive";
import { CreateBookingService } from 'src/app/bookings/create-booking/create-booking.service';
import { TimeValidationService } from 'src/app/bookings/shared/time-validation.service';
import { Moment, parseZone } from 'moment';
import {  Subject, combineLatest } from 'rxjs';
import { map, startWith, switchMap, takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';
import { CommonService } from '../../services/common.service';
import { TwelvehourtimeformatterPipe } from '../../pipes/twelvehourtimeformatter.pipe';


@Component({
    selector: 'app-time-picker',
    templateUrl: './time-picker.component.html',
    styleUrls: ['../../styles/form-input.scss', './time-picker.component.scss'],
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => TimePickerComponent),
        multi: true
      }
    ]
})

export class TimePickerComponent extends BaseControlValueAccessor<string>  implements OnInit {

  @Input() formControl: FormControl;
  @Input() showClear: boolean;
  @Input() twelveHour = false;
  @Input() dateControl: FormControl;
  @Input() editBillingTime: boolean;
  @Input() timeFormat: string = "HH:mm"; 

  @Output() changeCallback = new EventEmitter();

  @ViewChild("input", { static: true }) input: ElementRef;
  @ViewChild(TimepickerDirective) timepickerDirective: TimepickerDirective;

  @ViewChildren("timeInterval") set timeIntervalRefs(intervals) {
    intervals.forEach(interval => {
      if (interval.nativeElement.classList[0] === "highlight") {
        const highlighted = interval.nativeElement;
        setTimeout(() => highlighted.scrollIntoView({ block: "center" }));
      }
    });
  }

  interval = 15;
  openStatus = false;
  timeIntervals: string[] = [];
  dateAsEpoch: number = moment().valueOf();
  // timeFormat!: string;
  firstInterval: number;
  chosenTime: string;
  showBackdatedError = false;
  backdatedBooking = false;
  cutoff = 0;
  destroyer$: Subject<void> = new Subject();
  editTrue = true;
  dateControlData: Moment;
  constructor(private elementRef: ElementRef, private createBookingService: CreateBookingService, private timeValidatorService: TimeValidationService, private router: Router,private commonservice:CommonService, public twelveHourTimePipe : TwelvehourtimeformatterPipe) {
    super();
  }

  ngOnInit() {
    // this.timeFormat = "HH:mm" ;
    this.value = 'Time';
    if (this.router.url !== '/bookings/create')
    {
      this.editTrue = false;
    }
    if (this.dateControl === undefined){
      this.dateControl = new FormControl();
      this.dateControl.setValue(moment(new Date()));
    }
    this.createBookingService.createBackDatedBooking.subscribe(res => {
      if (res) { this.backdatedBooking = true; }
    }
);
    if (this.formControl && this.formControl.value) {
      this.editBillingTime ?  this.formControl.setValue(this.formControl.value.split(' ')[1]) :
      this.formControl.setValue(this.twelveHourTimePipe.transform(this.formControl.value));
    }
    const inputElt = this.elementRef.nativeElement.querySelector('.time-picker');
    Timepicker.init(inputElt, {
      defaultTime: this.formControl ? this.formControl.value : 'Time',
      container: '#time-picker-popup',
      showClearBtn: Boolean(this.showClear),
      twelveHour: this.twelveHour
    });


    this.createBookingService.dateChange.pipe(
        takeUntil(this.destroyer$),
        switchMap(() => combineLatest([
          this.dateControl.valueChanges.pipe(startWith(this.dateControl.value)),
          this.createBookingService.createBackDatedBooking,
          this.timeValidatorService.cutoffTime
        ])),
        map(([value, backdated, cutoff]) => {
          return {
            dateControlData : Array.isArray(value) ? value[0] : value,
            backdated,
            cutoff
          };
        }),
        takeUntil(this.destroyer$)
      ).subscribe(({dateControlData, backdated, cutoff }) => {

        this.handleDateChange(dateControlData, backdated, cutoff);
      });

  }

  handleDateChange(dateControlData: Moment, backdated: boolean, cutoff: number)
  {
    const value = dateControlData;
    this.dateControlData = Array.isArray(value) ? value[0] : value;
    if (this.dateControlData?.format("DD/MM/YYYY") === parseZone().format("DD/MM/YYYY") && !backdated && this.editTrue) {
              this.dateAsEpoch = moment(this.dateControlData).valueOf();
              this.cutoff = (Number.isNaN(cutoff) ? 0 : cutoff);
              const nearest15 = Math.ceil((moment(moment(new Date())).add(this.cutoff + 5, 'minutes').minute()) / 15) * 15;
              this.firstInterval = moment(moment(new Date())).add(this.cutoff + 5, 'minutes').minute(nearest15).second(0).millisecond(0).valueOf();
              const firstIntervalDay = moment(this.firstInterval).startOf('day');
              if (firstIntervalDay.isSame(moment().startOf('day'))) {
                  this.populateDropdown();
                } else {
                  this.timeIntervals = ["No times available today for selected Booking Type"];
                }
              }
              else
              {
                this.dateAsEpoch = moment(parseZone().format("DD/MM/YYYY"), 'DD,MM,YYYY').valueOf();
                this.firstInterval = moment(parseZone().format("DD/MM/YYYY"), "DD,MM,YYYY").valueOf();
                this.populateDropdown();
              }
  }


  openDropdown(): void {
    this.openStatus = true;
  }
  closeDropdown() {
    this.openStatus = false;
    if (this.timepickerDirective) { this.timepickerDirective.destroyOverlay(); }
  }
  onTimeSelect(e){
    this.value =this.twelveHourTimePipe.transform(e);
    let timevalue=e;
    this.openStatus = false;
    if (this.timepickerDirective) { this.timepickerDirective.destroyOverlay(); }
    this.onChange(timevalue);
    if (this.changeCallback) {
      this.changeCallback.emit(timevalue);
    }
  }
  populateDropdown(): void {
    this.timeIntervals = [];
    const dateAsString = moment(this.dateAsEpoch).format('DD-MM-YYYY');
    const intervalAsString = moment(this.firstInterval).format(this.timeFormat);
    const start = moment(`${dateAsString} ${intervalAsString}`, `DD-MM-YYYY ${this.timeFormat}`);
    const end = moment(`${dateAsString}`, 'DD-MM-YYYY').endOf('d');
    while (start.valueOf() < end.valueOf()) {
      this.timeIntervals.push(start.format(this.timeFormat));
      start.add(this.interval, "m");
    }
    if (this.timeIntervals.length === 0) {
      this.chosenTime = moment().endOf("d").format(this.timeFormat);
      this.timeIntervals.push(moment().endOf("d").format(this.timeFormat));
    }
  }

  onInputChange(e): void {
    this.value = e;
    this.createBookingService.createBackDatedBooking.subscribe(res => {
      this.backdatedBooking = res;
      if (res){
        const targetTime = typeof this.dateControlData['_i'] == 'string' ? moment(`${this.dateControlData['_i']} ${ e.target.value}`, "DD/MM/YYYY HH:mm").toDate() :  moment(`${this.formatDate(this.dateControlData['_i'])} ${ e.target.value}`, "DD/MM/YYYY HH:mm").toDate();
        this.showBackdatedError = targetTime > new Date() ? true : false;
      }
     });

    this.onChange(this.value);
    if (this.changeCallback) {
      this.changeCallback.emit(this.value);
    }
    this.destroyer$.next();
    this.destroyer$.complete();
  }
  formatDate(date) {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  showError(): boolean {
    return Boolean(this.formControl && this.formControl.errors && this.formControl.dirty);
  }

}
